exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "fieldset.ir-fieldset{width:100%;border:1px solid orange;border-radius:8px;padding:10px;margin-bottom:12px}fieldset.ir-fieldset legend{color:orange;padding:0 6px;margin-left:-6px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/Modules/FieldSet/FieldSet.less
 ** module id = 1061
 ** module chunks = 0
 **/